import { AnalyticsProvider } from "./AnalyticsProvider";

const noAnalyticsProvider: AnalyticsProvider = {};

export default noAnalyticsProvider;
